export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-01-01 13:00:00`. */
  DateTime: any
  /** Arbitrary data encoded in JavaScript Object Notation. See https://www.json.org/. */
  JSON: any
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: any
}

export type Block = {
  order: Scalars['Int']
}

export type ContactEmailInput = {
  object: Scalars['String']
  email: Scalars['String']
  text: Scalars['String']
  copy?: Maybe<Scalars['Boolean']>
}

export type CoverImages = {
  __typename?: 'CoverImages'
  desktop?: Maybe<Scalars['String']>
  mobile?: Maybe<Scalars['String']>
  alt?: Maybe<Scalars['String']>
}

export type Covers = {
  __typename?: 'Covers'
  planning?: Maybe<CoverImages>
  recipes_list?: Maybe<CoverImages>
}

export type Crosslink = {
  __typename?: 'Crosslink'
  title: Scalars['String']
  type: Scalars['String']
  image: Scalars['String']
  url: Scalars['String']
}

export type CustomFeaturedContent = {
  __typename?: 'CustomFeaturedContent'
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export enum Day {
  Day_1 = 'DAY_1',
  Day_2 = 'DAY_2',
  Day_3 = 'DAY_3',
  Day_4 = 'DAY_4',
  Day_5 = 'DAY_5',
  Day_6 = 'DAY_6',
  Day_7 = 'DAY_7',
}

export type Department = {
  __typename?: 'Department'
  id: Scalars['ID']
  name: Scalars['String']
  code?: Maybe<Scalars['String']>
}

/** A paginated list of Department items. */
export type DepartmentPaginator = {
  __typename?: 'DepartmentPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Department items. */
  data: Array<Department>
}

export type Event = {
  __typename?: 'Event'
  id: Scalars['ID']
  title: Scalars['String']
  slug?: Maybe<Scalars['String']>
  address: Scalars['String']
  paid: Scalars['Boolean']
  city: Scalars['String']
  department: Department
  date: Scalars['DateTime']
  publisher: Scalars['String']
  publisher_logo?: Maybe<Scalars['String']>
  description: Scalars['JSON']
  /** @deprecated Field no longer supported */
  duration?: Maybe<EventDuration>
  place: Place
  participation_terms?: Maybe<Scalars['JSON']>
  reservation_text?: Maybe<Scalars['JSON']>
  event_link?: Maybe<Scalars['String']>
  contact_link?: Maybe<Scalars['String']>
  contact_email?: Maybe<Scalars['String']>
  contact_phone?: Maybe<Scalars['String']>
  type?: Maybe<EventActivityType>
  /** @deprecated Field no longer supported */
  types?: Maybe<Array<EventActivityType>>
  /** @deprecated Field no longer supported */
  targets?: Maybe<Array<EventTarget>>
  accessibilityModes?: Maybe<Array<EventAccessibilityMode>>
}

export type EventAccessibilityMode = {
  __typename?: 'EventAccessibilityMode'
  id: Scalars['ID']
  name: Scalars['String']
}

/** A paginated list of EventAccessibilityMode items. */
export type EventAccessibilityModePaginator = {
  __typename?: 'EventAccessibilityModePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of EventAccessibilityMode items. */
  data: Array<EventAccessibilityMode>
}

export type EventActivityType = {
  __typename?: 'EventActivityType'
  id: Scalars['ID']
  title: Scalars['String']
  image_url?: Maybe<Scalars['String']>
}

/** A paginated list of EventActivityType items. */
export type EventActivityTypePaginator = {
  __typename?: 'EventActivityTypePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of EventActivityType items. */
  data: Array<EventActivityType>
}

export type EventDateRange = {
  __typename?: 'EventDateRange'
  start: Scalars['Date']
  end: Scalars['Date']
}

export enum EventDuration {
  TenMinutes = 'TEN_MINUTES',
  ThirtyMinutes = 'THIRTY_MINUTES',
  MoreThanOneHour = 'MORE_THAN_ONE_HOUR',
}

/** A paginated list of Event items. */
export type EventPaginator = {
  __typename?: 'EventPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Event items. */
  data: Array<Event>
}

export type EventTarget = {
  __typename?: 'EventTarget'
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
}

/** A paginated list of EventTarget items. */
export type EventTargetPaginator = {
  __typename?: 'EventTargetPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of EventTarget items. */
  data: Array<EventTarget>
}

export type EventWeek = {
  start: Scalars['Date']
  end: Scalars['Date']
}

export type FeaturedContent = {
  __typename?: 'FeaturedContent'
  title?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  content?: Maybe<Array<Maybe<FeaturedContentType>>>
}

export type FeaturedContentType = Recipe | CustomFeaturedContent | FeaturedTag

export type FeaturedTag = {
  __typename?: 'FeaturedTag'
  tag?: Maybe<Tag>
  title?: Maybe<Scalars['String']>
  headline?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['String']>
}

export type Ingredient = {
  __typename?: 'Ingredient'
  id: Scalars['ID']
  name: Scalars['String']
  plural?: Maybe<Scalars['String']>
  display_name?: Maybe<Scalars['String']>
  display_plural?: Maybe<Scalars['String']>
  with_pork?: Maybe<Scalars['Boolean']>
  ignore_shopping_list?: Maybe<Scalars['Boolean']>
  is_oil?: Maybe<Scalars['Boolean']>
  seasons?: Maybe<Array<Season>>
  frozen_or_canned?: Maybe<Scalars['Boolean']>
  pnns_category?: Maybe<PnnsCategory>
  store_shelf?: Maybe<StoreShelf>
  ingredient_recipe?: Maybe<IngredientRecipe>
  ingredient_recipe_step?: Maybe<IngredientRecipeStep>
  nutritional_value?: Maybe<NutritionalValue>
  unbreakable?: Maybe<Unbreakable>
}

export type IngredientEdge = {
  __typename?: 'IngredientEdge'
  cursor: Scalars['String']
  node: Ingredient
  quantity: Scalars['Float']
  measurement_unit: MeasurementUnit
}

export type IngredientRecipe = {
  __typename?: 'IngredientRecipe'
  quantity: Scalars['Float']
  gross_weight?: Maybe<Scalars['Float']>
  measurement_unit: MeasurementUnit
}

export type IngredientRecipeStep = {
  __typename?: 'IngredientRecipeStep'
  quantity: Scalars['Float']
  gross_weight?: Maybe<Scalars['Float']>
  measurement_unit: MeasurementUnit
}

export type IntroCard = {
  __typename?: 'IntroCard'
  tip_image: Scalars['String']
  tip_text: Scalars['String']
  push_image: Scalars['String']
  push_text: Scalars['String']
  push_cta_text: Scalars['String']
  push_cta_url: Scalars['String']
}

/** Nova-Translation Label type. */
export type Label = {
  __typename?: 'Label'
  /** Label type */
  type: Scalars['String']
  /** Label key */
  key: Scalars['String']
  /** Label value */
  value?: Maybe<Scalars['String']>
  /** Creation datetime */
  createdAt: Scalars['DateTime']
  /** Last update datetime */
  updatedAt: Scalars['DateTime']
  /** Locale ISO */
  locale: Scalars['String']
  /** Item translation ID */
  translationId: Scalars['Int']
}

/** Nova-Translation Locale type. */
export type Locale = {
  __typename?: 'Locale'
  /** Locale ID */
  id: Scalars['ID']
  /** Locale ISO */
  iso: Scalars['String']
  /** Locale label */
  label: Scalars['String']
  /** Locale fallback ID */
  fallbackId?: Maybe<Scalars['ID']>
  /** Locale fallback */
  fallback?: Maybe<Locale>
  /** Locale is available in API? */
  isAvailableInApi: Scalars['Boolean']
  /** Creation datetime */
  createdAt: Scalars['DateTime']
  /** Last update datetime */
  updatedAt: Scalars['DateTime']
}

/** Locales default input (nothing to fetch all locales) */
export type LocaleFilters = {
  /** Locale ISO */
  locale?: Maybe<Scalars['String']>
  /** A list of valid ISOs to fetch */
  locales?: Maybe<Array<Scalars['String']>>
}

export type LocationInput = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
}

export type MeasurementUnit = {
  __typename?: 'MeasurementUnit'
  name: Scalars['String']
  plural?: Maybe<Scalars['String']>
  use_ingredient_name?: Maybe<Scalars['Boolean']>
  round_type?: Maybe<RoundType>
}

export type MenuDay = {
  __typename?: 'MenuDay'
  day: Day
  moments?: Maybe<Array<MenuMoment>>
}

export type MenuMoment = {
  __typename?: 'MenuMoment'
  moment: Moment
  meal?: Maybe<Array<Recipe>>
}

export enum Moment {
  Lunch = 'LUNCH',
  Dinner = 'DINNER',
}

export enum MomentPreference {
  OnlyLunch = 'ONLY_LUNCH',
  LunchAndDinner = 'LUNCH_AND_DINNER',
  OnlyDinner = 'ONLY_DINNER',
}

export enum Month {
  January = 'JANUARY',
  February = 'FEBRUARY',
  Mach = 'MACH',
  April = 'APRIL',
  May = 'MAY',
  June = 'JUNE',
  July = 'JULY',
  August = 'AUGUST',
  September = 'SEPTEMBER',
  October = 'OCTOBER',
  November = 'NOVEMBER',
  December = 'DECEMBER',
}

export type Mutation = {
  __typename?: 'Mutation'
  submitQuiz: User
  refreshToken?: Maybe<Scalars['String']>
  invalidateToken: Scalars['Boolean']
  onboard: User
  starRecipes?: Maybe<User>
  unstarRecipes?: Maybe<User>
  associateToken?: Maybe<User>
  updateNotificationPreference?: Maybe<User>
  UpdatePushPreferences?: Maybe<User>
  updateDownloadPreferences?: Maybe<User>
  drawPlan?: Maybe<UserPlan>
  replaceRecipeInPlan: UserPlan
  changeStartDateOfPlan: UserPlan
}

export type MutationSubmitQuizArgs = {
  question_1: QuizUserType
  question_2: Scalars['Boolean']
  question_3?: Maybe<Scalars['Int']>
  question_4?: Maybe<Scalars['Int']>
  question_5: Scalars['Boolean']
  question_6?: Maybe<Scalars['Int']>
  question_7?: Maybe<Scalars['Int']>
  question_8: SchoolDuration
  question_9: Scalars['Boolean']
  question_9_bis?: Maybe<Scalars['Int']>
  question_10?: Maybe<Scalars['Int']>
  question_11: Scalars['Boolean']
  question_12?: Maybe<Scalars['Int']>
  question_13?: Maybe<Scalars['Int']>
  question_14: Scalars['Boolean']
  question_14_bis: Scalars['Boolean']
  question_15?: Maybe<RecurrenceInput>
  question_15_bis?: Maybe<RecurrenceInput>
  question_16: QuizDuration
  question_17: QuizDuration
}

export type MutationOnboardArgs = {
  preferences: PreferencesInput
  objectives: ObjectivesInput
}

export type MutationStarRecipesArgs = {
  recipes: Array<Scalars['ID']>
}

export type MutationUnstarRecipesArgs = {
  recipes: Array<Scalars['ID']>
}

export type MutationAssociateTokenArgs = {
  token: Scalars['String']
}

export type MutationUpdateNotificationPreferenceArgs = {
  should_receive_notifications: Scalars['Boolean']
  notification_frequency?: Maybe<NotificationFrequency>
}

export type MutationUpdatePushPreferencesArgs = {
  installIOS: Scalars['Boolean']
  installAndroid: Scalars['Boolean']
  notification: Scalars['Boolean']
}

export type MutationUpdateDownloadPreferencesArgs = {
  hasDownloadMenu: Scalars['Boolean']
}

export type MutationDrawPlanArgs = {
  season?: Maybe<Season>
  previous?: Maybe<Scalars['ID']>
}

export type MutationReplaceRecipeInPlanArgs = {
  plan: Scalars['ID']
  day: Day
  moment: Moment
  previous: Scalars['ID']
  recipe: Scalars['ID']
}

export type MutationChangeStartDateOfPlanArgs = {
  plan: Scalars['ID']
  start_date: Scalars['Date']
}

export enum NotificationFrequency {
  Weekly = 'WEEKLY',
  Daily = 'DAILY',
}

export enum Nutriscore {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

export type NutritionalValue = {
  __typename?: 'NutritionalValue'
  name: Scalars['String']
  net_weight?: Maybe<Scalars['Float']>
  gross_weight?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  net_gross_weight_ratio?: Maybe<Scalars['Float']>
  kcal?: Maybe<Scalars['Float']>
  theoretical_kcal?: Maybe<Scalars['Float']>
  delta_kcal?: Maybe<Scalars['Float']>
  kj?: Maybe<Scalars['Float']>
  lipids?: Maybe<Scalars['Float']>
  saturated_fatty_acids?: Maybe<Scalars['Float']>
  carbohydrates?: Maybe<Scalars['Float']>
  simple_sugars?: Maybe<Scalars['Float']>
  fibres?: Maybe<Scalars['Float']>
  proteins?: Maybe<Scalars['Float']>
  salt?: Maybe<Scalars['Float']>
  water?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  fats?: Maybe<Scalars['Float']>
}

export type Objectives = {
  __typename?: 'Objectives'
  fruit_and_vegetable?: Maybe<Scalars['Int']>
  complete_carbohydrate?: Maybe<Scalars['Int']>
  dried_vegetable?: Maybe<Scalars['Int']>
  meat?: Maybe<Scalars['Int']>
  fish?: Maybe<Scalars['Int']>
  sugary_product?: Maybe<Scalars['Int']>
}

export type ObjectivesInput = {
  fruit_and_vegetable: Scalars['Int']
  complete_carbohydrate: Scalars['Int']
  dried_vegetable: Scalars['Int']
  meat: Scalars['Int']
  fish: Scalars['Int']
  sugary_product?: Maybe<Scalars['Int']>
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']
  /** The direction that is used for ordering. */
  order: SortOrder
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Minimum. */
  Min = 'MIN',
  /** Maximum. */
  Max = 'MAX',
  /** Sum. */
  Sum = 'SUM',
  /** Amount of items. */
  Count = 'COUNT',
}

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']
  /** Number of nodes in the current page. */
  count: Scalars['Int']
  /** Index of the current page. */
  currentPage: Scalars['Int']
  /** Index of the last available page. */
  lastPage: Scalars['Int']
}

export type PaginatedRecommendation = {
  __typename?: 'PaginatedRecommendation'
  paginatorInfo: PaginatorInfo
  data: Array<Recommendation>
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo'
  /** Number of items in the current page. */
  count: Scalars['Int']
  /** Index of the current page. */
  currentPage: Scalars['Int']
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>
  /** Index of the last available page. */
  lastPage: Scalars['Int']
  /** Number of items per page. */
  perPage: Scalars['Int']
  /** Number of total available items. */
  total: Scalars['Int']
}

export enum PhysicalProfile {
  Profile_1 = 'PROFILE_1',
  Profile_2 = 'PROFILE_2',
  Profile_3 = 'PROFILE_3',
  Profile_4 = 'PROFILE_4',
  Profile_5 = 'PROFILE_5',
  Profile_6 = 'PROFILE_6',
  Profile_7 = 'PROFILE_7',
  Profile_8 = 'PROFILE_8',
}

export enum Place {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR',
  Both = 'BOTH',
}

export enum PlanStructure {
  EntPlatDessert = 'ENT_PLAT_DESSERT',
  EntPlat = 'ENT_PLAT',
  PlatDessert = 'PLAT_DESSERT',
}

export enum PnnsCategory {
  AnimalFat = 'ANIMAL_FAT',
  Carbohydrate = 'CARBOHYDRATE',
  Cheese = 'CHEESE',
  CompleteCarbohydrate = 'COMPLETE_CARBOHYDRATE',
  DairyProduct = 'DAIRY_PRODUCT',
  Delicatessen = 'DELICATESSEN',
  DriedVegetable = 'DRIED_VEGETABLE',
  Drink = 'DRINK',
  Egg = 'EGG',
  FattyFish = 'FATTY_FISH',
  Fruit = 'FRUIT',
  FruitAndVegetable = 'FRUIT_AND_VEGETABLE',
  Meat = 'MEAT',
  Milk = 'MILK',
  NonCompleteCarbohydrate = 'NON_COMPLETE_CARBOHYDRATE',
  NonFattyFish = 'NON_FATTY_FISH',
  NonPoultryMeat = 'NON_POULTRY_MEAT',
  Nuts = 'NUTS',
  Other = 'OTHER',
  Poultry = 'POULTRY',
  Salt = 'SALT',
  SugarProduct = 'SUGAR_PRODUCT',
  Vegetable = 'VEGETABLE',
  VegetableFat = 'VEGETABLE_FAT',
  Yoghurt = 'YOGHURT',
}

export type Preferences = {
  __typename?: 'Preferences'
  portions?: Maybe<Scalars['Int']>
  regime?: Maybe<Regime>
  structure?: Maybe<PlanStructure>
  express?: Maybe<Scalars['Boolean']>
  moment?: Maybe<MomentPreference>
}

export type PreferencesInput = {
  portions: Scalars['Int']
  regime: Regime
  structure: PlanStructure
  express?: Maybe<Scalars['Boolean']>
  moment?: Maybe<MomentPreference>
}

export enum PublicationPlatform {
  Fam = 'FAM',
  MangerBouger = 'MANGER_BOUGER',
}

export type QapaPage = {
  __typename?: 'QapaPage'
  cover_image?: Maybe<Scalars['String']>
  cover_title: Scalars['String']
  intro_text?: Maybe<Scalars['JSON']>
  intro_video?: Maybe<Video>
  intro_tip_and_push?: Maybe<IntroCard>
  tips_title: Scalars['String']
  tips?: Maybe<Array<QapaTip>>
}

export type QapaTip = {
  __typename?: 'QapaTip'
  type: QapaTipType
  title: Scalars['String']
  image: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export enum QapaTipType {
  Activity = 'ACTIVITY',
  Article = 'ARTICLE',
  Recommendation = 'RECOMMENDATION',
  Tool = 'TOOL',
}

export type Query = {
  __typename?: 'Query'
  eventBySlug?: Maybe<Event>
  quiz?: Maybe<Quiz>
  recipeById?: Maybe<Recipe>
  recipeBySlug?: Maybe<Recipe>
  settings: Settings
  getOnboardingTips?: Maybe<Tips>
  getRandomLoadingMessage?: Maybe<Array<Maybe<Scalars['String']>>>
  getQapaPage: QapaPage
  getEventDates?: Maybe<Array<EventDateRange>>
  me?: Maybe<User>
  userPlan?: Maybe<UserPlan>
  /** Fetch all locales */
  locales: Array<Locale>
  /** Locale by ID */
  localeById?: Maybe<Locale>
  /** Locale by ISO */
  localeByIso?: Maybe<Locale>
  /** Fetch labels by locale ISO */
  labels: Array<Label>
  checkMemory?: Maybe<Scalars['String']>
  departments?: Maybe<DepartmentPaginator>
  events?: Maybe<EventPaginator>
  eventAccessibilityModes?: Maybe<EventAccessibilityModePaginator>
  eventActivityTypes?: Maybe<EventActivityTypePaginator>
  eventTargets?: Maybe<EventTargetPaginator>
  quizzes?: Maybe<QuizPaginator>
  recipeSearch?: Maybe<RecipePaginator>
  /** @deprecated Field no longer supported */
  recipesByFilter?: Maybe<RecipePaginator>
  recipesByThemes?: Maybe<RecipePaginator>
  recipes?: Maybe<RecipePaginator>
  findReplacement?: Maybe<RecipePaginator>
}

export type QueryEventBySlugArgs = {
  slug: Scalars['String']
}

export type QueryQuizArgs = {
  id: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  page?: Maybe<Scalars['Int']>
}

export type QueryRecipeByIdArgs = {
  id: Scalars['ID']
}

export type QueryRecipeBySlugArgs = {
  slug: Scalars['String']
}

export type QueryUserPlanArgs = {
  id: Scalars['ID']
}

export type QueryLocaleByIdArgs = {
  id: Scalars['ID']
}

export type QueryLocaleByIsoArgs = {
  iso: Scalars['String']
}

export type QueryLabelsArgs = {
  localeFilters?: Maybe<LocaleFilters>
}

export type QueryDepartmentsArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryEventsArgs = {
  query?: Maybe<Scalars['String']>
  paid?: Maybe<Scalars['Boolean']>
  types?: Maybe<Array<Scalars['ID']>>
  departments?: Maybe<Array<Scalars['ID']>>
  places?: Maybe<Array<Place>>
  modes?: Maybe<Array<Scalars['ID']>>
  weeks?: Maybe<Array<EventWeek>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryEventAccessibilityModesArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryEventActivityTypesArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryEventTargetsArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryQuizzesArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryRecipeSearchArgs = {
  query?: Maybe<Scalars['String']>
  type?: Maybe<Array<RecipeCategory>>
  regime?: Maybe<Regime>
  express?: Maybe<Scalars['Boolean']>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryRecipesByFilterArgs = {
  express?: Maybe<Scalars['Boolean']>
  type?: Maybe<Array<Maybe<RecipeType>>>
  regime?: Maybe<Regime>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryRecipesByThemesArgs = {
  themes?: Maybe<Array<Scalars['String']>>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryRecipesArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type QueryFindReplacementArgs = {
  recipe: Scalars['ID']
  use_same_main_component?: Maybe<Scalars['Boolean']>
  regime?: Maybe<Regime>
  express?: Maybe<Scalars['Boolean']>
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type Quiz = {
  __typename?: 'Quiz'
  id: Scalars['ID']
  daily_physical_activity: Scalars['Float']
  daily_physical_activity_reached: Scalars['Boolean']
  intense_physical_activity: Scalars['Float']
  intense_physical_activity_reached: Scalars['Boolean']
  screen_time: Scalars['Float']
  screen_time_reached: Scalars['Boolean']
  recommendation_profile: RecommendationProfile
  physical_profile: PhysicalProfile
  texts?: Maybe<QuizTexts>
  /** @deprecated Field no longer supported */
  recommendations?: Maybe<Array<Recommendation>>
  paginated_recommendations?: Maybe<PaginatedRecommendation>
  created_at?: Maybe<Scalars['DateTime']>
}

export type QuizPaginated_RecommendationsArgs = {
  first?: Maybe<Scalars['Int']>
  page?: Maybe<Scalars['Int']>
}

export enum QuizDuration {
  Duration_4 = 'DURATION_4',
  Duration_1 = 'DURATION_1',
  Duration_3 = 'DURATION_3',
  Duration_2 = 'DURATION_2',
}

/** A paginated list of Quiz items. */
export type QuizPaginator = {
  __typename?: 'QuizPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Quiz items. */
  data: Array<Quiz>
}

export type QuizTexts = {
  __typename?: 'QuizTexts'
  recommendation?: Maybe<Scalars['JSON']>
  physical_activity?: Maybe<Scalars['JSON']>
}

export enum QuizUserType {
  Parent = 'PARENT',
  Pro = 'PRO',
  Teen = 'TEEN',
}

export type Recipe = {
  __typename?: 'Recipe'
  id: Scalars['ID']
  name: Scalars['String']
  slug: Scalars['String']
  preparation_time?: Maybe<Scalars['Int']>
  baking_time?: Maybe<Scalars['Int']>
  rest_time?: Maybe<Scalars['Int']>
  benefits?: Maybe<Scalars['String']>
  portions?: Maybe<Scalars['Int']>
  min_portions?: Maybe<Scalars['Int']>
  max_portions?: Maybe<Scalars['Int']>
  unbreakable?: Maybe<Unbreakable>
  regime?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['String']>
  image_alt?: Maybe<Scalars['String']>
  image_desktop?: Maybe<Scalars['String']>
  image_mobile?: Maybe<Scalars['String']>
  cover?: Maybe<Scalars['String']>
  cover_alt?: Maybe<Scalars['String']>
  /** @deprecated Field no longer supported */
  cover_desktop?: Maybe<Scalars['String']>
  /** @deprecated Field no longer supported */
  cover_mobile?: Maybe<Scalars['String']>
  video?: Maybe<Video>
  publication_platforms?: Maybe<Array<PublicationPlatform>>
  published?: Maybe<Scalars['Boolean']>
  archived?: Maybe<Scalars['Boolean']>
  recipe_category: RecipeCategory
  seasons?: Maybe<Array<Season>>
  season_type: SeasonType
  express?: Maybe<Scalars['Boolean']>
  nutriscore?: Maybe<Nutriscore>
  ranking?: Maybe<Scalars['String']>
  main_component?: Maybe<Scalars['String']>
  family_recipe?: Maybe<Scalars['Boolean']>
  parent?: Maybe<Scalars['Boolean']>
  children_recipes?: Maybe<Array<Recipe>>
  /** @deprecated Field no longer supported */
  per_person_net_weight?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_gross_weight?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_net_gross_weight_ratio?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_kcal?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_theoretical_kcal?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_delta_kcal?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_kj?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_lipids?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_saturated_fatty_acids?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_carbohydrates?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_simple_sugars?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_fibres?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_proteins?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_salt?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_oils?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_water?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_fruits_and_vegetables?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_fruits?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_vegetables?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_dry_vegetables?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_shell_fruits?: Maybe<Scalars['Float']>
  /** @deprecated Field no longer supported */
  per_person_fats?: Maybe<Scalars['Float']>
  kcal_per_100_g?: Maybe<Scalars['Float']>
  kj_per_100_g?: Maybe<Scalars['Float']>
  lipids_per_100_g?: Maybe<Scalars['Float']>
  saturated_fatty_acids_per_100_g?: Maybe<Scalars['Float']>
  carbohydrates_per_100_g?: Maybe<Scalars['Float']>
  simple_sugars_per_100_g?: Maybe<Scalars['Float']>
  fibres_per_100_g?: Maybe<Scalars['Float']>
  proteins_per_100_g?: Maybe<Scalars['Float']>
  salt_per_100_g?: Maybe<Scalars['Float']>
  oils_per_100_g?: Maybe<Scalars['Float']>
  water_per_100_g?: Maybe<Scalars['Float']>
  pnns_fruit_per_100_g?: Maybe<Scalars['Float']>
  pnns_vegetable_per_100_g?: Maybe<Scalars['Float']>
  pnns_dried_vegetable_per_100_g?: Maybe<Scalars['Float']>
  pnns_nuts_per_100_g?: Maybe<Scalars['Float']>
  steps?: Maybe<Array<RecipeStep>>
  ingredients?: Maybe<Array<Ingredient>>
  tags?: Maybe<Array<Maybe<Tag>>>
}

export enum RecipeCategory {
  Course = 'COURSE',
  Dessert = 'DESSERT',
  FullCourse = 'FULL_COURSE',
  Other = 'OTHER',
  Side = 'SIDE',
  Start = 'START',
}

/** A paginated list of Recipe items. */
export type RecipePaginator = {
  __typename?: 'RecipePaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of Recipe items. */
  data: Array<Recipe>
}

export type RecipeStep = {
  __typename?: 'RecipeStep'
  order: Scalars['Int']
  text?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['String']>
  image_alt?: Maybe<Scalars['String']>
  video?: Maybe<Video>
  family_profile?: Maybe<Scalars['String']>
  ingredients?: Maybe<Array<Ingredient>>
}

export enum RecipeType {
  Meal = 'MEAL',
  Dessert = 'DESSERT',
  Starter = 'STARTER',
  Side = 'SIDE',
}

export type Recommendation = {
  __typename?: 'Recommendation'
  id: Scalars['ID']
  title: Scalars['String']
  type: RecommendationType
  image: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export enum RecommendationProfile {
  ProfileA = 'PROFILE_A',
  ProfileB = 'PROFILE_B',
  ProfileC = 'PROFILE_C',
  ProfileD = 'PROFILE_D',
}

export enum RecommendationType {
  Article = 'ARTICLE',
  Tip = 'TIP',
}

export type RecurrenceInput = {
  recurrence: Scalars['Int']
  duration: Scalars['Int']
}

export enum Regime {
  NoEgg = 'NO_EGG',
  NoFish = 'NO_FISH',
  NoMeat = 'NO_MEAT',
  NoPork = 'NO_PORK',
  All = 'ALL',
}

export enum RoundType {
  Round_1 = 'ROUND_1',
  Round_2 = 'ROUND_2',
  Round_3 = 'ROUND_3',
}

export enum SchoolDuration {
  Duration_0 = 'DURATION_0',
  Duration_2 = 'DURATION_2',
  Duration_3 = 'DURATION_3',
  Duration_4 = 'DURATION_4',
  Duration_6 = 'DURATION_6',
}

export enum Season {
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Autumn = 'AUTUMN',
  Winter = 'WINTER',
}

export enum SeasonType {
  Seasonal = 'SEASONAL',
  SeasonalWithFrozen = 'SEASONAL_WITH_FROZEN',
  NotInSeason = 'NOT_IN_SEASON',
}

export type Settings = {
  __typename?: 'Settings'
  did_you_know?: Maybe<Scalars['JSON']>
  did_you_know_plate_change?: Maybe<Scalars['JSON']>
  highlighted_recipes?: Maybe<Array<Recipe>>
  push_register_image?: Maybe<Scalars['String']>
  push_register_image_alt?: Maybe<Scalars['String']>
  crosslink_planning?: Maybe<Array<Maybe<Crosslink>>>
  crosslink_recipes?: Maybe<Array<Maybe<Crosslink>>>
  featured?: Maybe<FeaturedContent>
  covers?: Maybe<Covers>
  sso_login_url?: Maybe<Scalars['String']>
  sso_logout_url?: Maybe<Scalars['String']>
  sso_account_url?: Maybe<Scalars['String']>
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo'
  /** Number of items in the current page. */
  count: Scalars['Int']
  /** Index of the current page. */
  currentPage: Scalars['Int']
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>
  /** Number of items per page. */
  perPage: Scalars['Int']
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC',
}

export type StoreShelf = {
  __typename?: 'StoreShelf'
  name: Scalars['String']
}

export type Tag = {
  __typename?: 'Tag'
  name: Scalars['String']
  type?: Maybe<Scalars['String']>
}

export type TimesStamps = {
  created_at?: Maybe<Scalars['DateTime']>
  updated_at?: Maybe<Scalars['DateTime']>
}

export type Tips = {
  __typename?: 'Tips'
  people_count?: Maybe<Scalars['String']>
  diet_practice?: Maybe<Scalars['String']>
  course_composition?: Maybe<Scalars['String']>
  express?: Maybe<Scalars['String']>
  course_range?: Maybe<Scalars['String']>
  fruits_vegetables_quantity?: Maybe<Scalars['String']>
  starchy_foods_frequency?: Maybe<Scalars['String']>
  dried_vegetables_frequency?: Maybe<Scalars['String']>
  fish_frequency?: Maybe<Scalars['String']>
  meat_frequency?: Maybe<Scalars['String']>
  drink_frequency?: Maybe<Scalars['String']>
  optimal?: Maybe<Scalars['String']>
  optimal_title?: Maybe<Scalars['String']>
  medium?: Maybe<Scalars['String']>
  medium_title?: Maybe<Scalars['String']>
  minium?: Maybe<Scalars['String']>
  minium_title?: Maybe<Scalars['String']>
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT',
}

export enum Unbreakable {
  Partial = 'PARTIAL',
  Complete = 'COMPLETE',
}

export type User = {
  __typename?: 'User'
  id: Scalars['ID']
  token?: Maybe<Scalars['String']>
  preferences?: Maybe<Preferences>
  objectives?: Maybe<Objectives>
  should_receive_notifications?: Maybe<Scalars['Boolean']>
  notification_frequency?: Maybe<NotificationFrequency>
  push_preferences?: Maybe<UserPushPreferences>
  current_plan?: Maybe<UserPlan>
  favorite_recipes?: Maybe<Array<Recipe>>
  latest_quiz?: Maybe<Quiz>
  quizzes?: Maybe<Array<Quiz>>
  has_download_menu?: Maybe<Scalars['Boolean']>
  plans?: Maybe<UserPlanPaginator>
}

export type UserPlansArgs = {
  first: Scalars['Int']
  page?: Maybe<Scalars['Int']>
}

export type UserPlan = {
  __typename?: 'UserPlan'
  id: Scalars['ID']
  regime?: Maybe<Regime>
  pnns_choice: Scalars['Int']
  structure: PlanStructure
  preferences?: Maybe<Preferences>
  objectives?: Maybe<Objectives>
  express?: Maybe<Scalars['Int']>
  start_at: Scalars['Date']
  created_at: Scalars['DateTime']
  menu?: Maybe<Array<MenuDay>>
}

/** A paginated list of UserPlan items. */
export type UserPlanPaginator = {
  __typename?: 'UserPlanPaginator'
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo
  /** A list of UserPlan items. */
  data: Array<UserPlan>
}

export type UserPushPreferences = {
  __typename?: 'UserPushPreferences'
  installIOS?: Maybe<Scalars['Boolean']>
  installAndroid?: Maybe<Scalars['Boolean']>
  notification?: Maybe<Scalars['Boolean']>
}

export type Video = {
  __typename?: 'Video'
  file: Scalars['String']
  poster?: Maybe<Scalars['String']>
  transcript?: Maybe<Scalars['String']>
}
